import React, { useState } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import './StripeCheckout.css';
import axios from 'axios';
import CardSection from './CardSection';

const CheckoutForm = ({ 
  clientSecret, 
  viewerId,
  companyEndpoint,
  videoId, 
  item 
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const API_URL = " https://do2v45e3qi.execute-api.us-west-2.amazonaws.com/production";

  // add the paid video to the users paid video  bucket
  const fetchPaid = async() =>{
    await axios.post(`${API_URL}/video-has-been-paid`,{
      videoId,
      viewerId,
      item
    });
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    // Stripe.js has not yet loaded.
    // Make sure to disable form submission until Stripe.js has loaded.
    if (!stripe || !elements) return;

    setIsLoading(true);

    const {paymentIntent, error} = await stripe.confirmCardPayment(clientSecret,
        {
          payment_method: {
            card: elements.getElement(CardElement),
          }
        }
    );

    if (error) {
      // Show error to your customer (for example, insufficient funds)
      setMessage(error.message);
    } else {
      // The payment has been processed!
      if (paymentIntent.status === 'succeeded') {
        // Show a success message to your customer
        setMessage('Payment Success');
        await fetchPaid();
        window.location = `${window.location.origin}/vod/${companyEndpoint}/video/${videoId}?page=HOME`;
        // There's a risk of the customer closing the window before callback
        // execution. Set up a webhook or plugin to listen for the
        // payment_intent.succeeded event that handles any business critical
        // post-payment actions.
      }
    }
    
    setIsLoading(false);
  };

  return (
    <form className="checkout-form" onSubmit={handleSubmit}>
      <CardSection />
      <button className='pay-now' disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </button>
        {message && <p>{message}</p>}
    </form>
  );
}

export default CheckoutForm;